module.exports = __webpack_public_path__ + "static/img/7.945b519.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/7/1/16/sp/7.png
// module id = xsX4
// module chunks = 0